<template>
  <div id="registe">
    <div class="bg">
      <div>
        <div class="header">用户注册</div>
        <div class="box">
          <el-row class="cells">
            <el-col :span="24">
              <el-input placeholder="请输入邮箱" maxlength="30" v-model="email"></el-input>
            </el-col>
          </el-row>
          <el-row class="cells">
            <el-col :span="24">
              <el-input placeholder="请输入密码" minlength="6" maxlength="30" :show-password="true" v-model="password"></el-input>
            </el-col>
          </el-row>
          <el-row class="cells">
            <el-col :span="24">
              <el-input placeholder="请再次输入密码" minlength="6" maxlength="30" :show-password="true" v-model="repassword"></el-input>
            </el-col>
          </el-row>
          <el-row class="cells">
            <el-col :span="24">
              <el-select style="width:100%" v-model="iscompanyhr" placeholder="请选择账号类型">
                <el-option label="企业HR" value="企业HR" key="0"></el-option>
                <el-option label="服务商账号" value="服务商账号" key="1"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="cells">
            <el-col :span="16">
              <el-input placeholder="请输入验证码" minlength="6" maxlength="6" @keyup.enter.native="doRegiste" v-model="verify"></el-input>
            </el-col>
            <el-col :span="8">
              <el-button type="danger" :loading="loading" style="width:100%"  :disabled="disabled" @click="getVerify">获取验证码</el-button>
            </el-col>
          </el-row>
          <!-- <el-row class="cells">
            <el-col :span="24">
              <el-input placeholder="邀请码(非必填)" maxlength="5" minlength="1"  v-model="inviteCode"></el-input>
            </el-col>
          </el-row> -->
          <el-row class="cells">
            <el-col :span="24">
              <el-button type="primary" style="width:100%" :loading="loading"  @click="doRegiste">立即注册</el-button>
            </el-col>
          </el-row>
          <el-row class="cells">
            <el-col :span="12">
              <span><router-link to="/login">已有账号，直接登录</router-link></span>
            </el-col>
            <el-col :span="12" style="text-align:right">
              <span><router-link to="/forget">忘记密码</router-link></span>
            </el-col>
          </el-row>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpers from '../helper';
export default {
  name:'registe',
  data(){
    return {
      email:'',
      password:'',
      repassword:'',
      verify:'',
      loading:false,
      disabled:false,
      iscompanyhr:'',
      inviteCode:'',
      source:'http://www.wisechoices.cn'
    }
  },
  created(){
    let inviteCode = this.$route.query.inviteCode
    console.log( inviteCode )
    if(inviteCode!=undefined && inviteCode != '' && inviteCode != null){
      this.inviteCode = inviteCode
      localStorage.setItem('inviteCode',inviteCode)
    }
  },
  methods:{
    doRegiste(){
      if(this.email == '' || this.password == "" || this.repassword == "" || this.iscompanyhr == "" || this.verify == ""){
        return this.$message.error("请填写完整信息");
      }    
      let checkEmail = helpers.checkEmail(this.email);
      if(checkEmail.code != 200){
        return this.$message.error(checkEmail.msg);
      }
      let checkPassword = helpers.checkPassword(this.password);
      if(checkPassword.code != 200){
        return this.$message.error(checkPassword.msg);
      }

      let checkRepassword = helpers.checkPassword(this.repassword);
      if(checkRepassword.code != 200){
        return this.$message.error(checkRepassword.msg);        
      }
      if(this.password != this.repassword){
        return this.$message.error('两次密码不一致');         
      }
      
      // if(this.inviteCode != ''){
      //   let checkInviteCode = helpers.checkNum(this.inviteCode);
      //   if(checkInviteCode.code != 200){
      //     return this.$message.error(checkInviteCode.msg);        
      //   }
      // }
      let inviteCode = localStorage.getItem('inviteCode')
      if(inviteCode!=undefined && inviteCode != '' && inviteCode != null){
        this.inviteCode = inviteCode
      }
      this.loading = true;
      let _this = this;
      this.$http.post(
        helpers.BASE_URL + '/api/user/public/register',        
        {username:this.email,password:this.password,verification_code:this.verify,iscompanyhr:this.iscompanyhr,source:this.source,inviteCode:this.inviteCode}
      )
      .then(function(response){
        //console.log(response.data);
        if(response.data.code === 1 ){
          _this.loading = false;
          _this.$router.push('/login');
          _this.$message({
            message: response.data.msg,
            type: 'success'
          });
          _this.disabled = true;
        }else{
          _this.loading = false;
          return _this.$message.error(response.data.msg);
        }
      })
      .catch(function (error) {
        //console.log(error);
      });
    },
    getVerify(){
      let _this = this;
      this.$http.post(
        helpers.BASE_URL + '/api/user/verification_code/send',        
        {username:this.email}
      )
      .then(function(response){
        //console.log(response.data);
        if(response.data.code === 1 ){
          _this.$message({
            message: response.data.msg,
            type: 'success'
          });
          _this.disabled = true;
        }else{
          _this.$message.error(response.data.msg);
        }
      })
      .catch(function (error) {
        //console.log(error);
      });
    }
  }
}
</script>
<style scoped>
.bg{
  background-image: url(../assets/images/login_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #59daf7;
  width: 100%;
  height:100vh;
}
.header{
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  padding-top: 20px;
}
.box{
  background-color:#ffffff;
  padding: 40px 80px;
  width: 300px;
  margin: 40px auto;
}
.cells{
  margin-top: 20px;
}
.cells:nth-last-child(1){
  margin-top: 20px;
  font-size: 12px;
}
.cells:nth-last-child(1) a{
  color: #939393;
}
.verify{
  width: 100%;
  height:40px
}
</style>